export default __webpack_public_path__ + "static/media/img--pool.035de1a0.jpg";